import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "WindowAuto"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 3H12.75V5.25H11.25V3ZM18.75 11.25H21V12.75H18.75V11.25ZM11.25 18.75H12.75V21H11.25V18.75ZM3 11.25H5.25V12.75H3V11.25ZM5.08266 6.14177L6.14241 5.08127L7.73316 6.67127L6.67266 7.73252L5.08266 6.14177ZM16.2654 6.67499L17.8561 5.08499L18.9166 6.14549L17.3266 7.73624L16.2654 6.67499ZM16.2646 17.3228L17.3251 16.2615L18.9159 17.853L17.8554 18.9135L16.2646 17.3228ZM5.08493 17.85L6.67493 16.2585L7.73543 17.319L6.14468 18.9105L5.08493 17.85ZM3 22.5H21V24H3V22.5ZM3 0H21V1.5H3V0ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5 9.51472 14.4853 7.5 12 7.5ZM9 12C9 10.3431 10.3431 9 12 9V15C10.3431 15 9 13.6569 9 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/WindowAuto.vue"]]);
